import { useTranslation } from 'react-i18next';
import { useSaveResource } from 'RestAPIs/useSaveResource';
import { ADMIN_SETTINGS_GROUP } from 'RestAPIs/endpoints';
import { isNil } from 'ramda';
import { AdminSettingsFormWrapper } from 'components/shared/AdminSettings/AdminSettingsFormWrapper';
import { useGetAdminSettings } from '../../../../queries';
import { AdminSettingsResponse } from '../../../types';
import {
  transformAdminSettingsToFormValues,
  transformAdminSettingsToRequestValues
} from '../../../utils';
import * as yup from 'yup';
import FormContent from './components/FormContent';
import { SectionSkeleton } from 'components/shared/MultiStepForm/Skeletons/SectionSkeleton';

const schema = yup.object({
  duty_duration_difference: yup.number().required(),
  preferred_function_match: yup.boolean()
});

const groupName = 'duty-exchange';

const DutyExchange = () => {
  const { t } = useTranslation('common');
  const { data = [], isFetching } =
    useGetAdminSettings<AdminSettingsResponse>(groupName);

  const { mutate, isLoading } = useSaveResource({
    url: `${ADMIN_SETTINGS_GROUP}`,
    id: data[0]?.groupId,
    invalidateQueryKey: [groupName],
    message: { error: t('travelCost.saveErrorMessage') }
  });

  const onSubmit = (formData) => {
    const payload = {
      ...data[0],
      settings: transformAdminSettingsToRequestValues(
        formData,
        data[0]?.settings
      )
    };

    mutate(payload);
  };

  return (
    <div style={{ paddingTop: '25px' }}>
      {isFetching || isNil(data[0].settings) ? (
        <SectionSkeleton height={60} width={835} />
      ) : (
        <AdminSettingsFormWrapper
          submitForm={onSubmit}
          schema={schema}
          isFetching={isFetching}
          isLoading={isLoading}
          data={transformAdminSettingsToFormValues(data[0])}
        >
          <FormContent />
        </AdminSettingsFormWrapper>
      )}
    </div>
  );
};

export default DutyExchange;
